"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtErrorCode = exports.BroadcastTypes = exports.SyncRequestTypes = void 0;
/**
 * The type of request message that is sent out actively
 */
var SyncRequestTypes;
(function (SyncRequestTypes) {
    /**
     * Establish a long connection channel
     */
    SyncRequestTypes["WATCH_ROOM"] = "WATCH_ROOM";
    /**
     * leave the collaboration room
     */
    SyncRequestTypes["LEAVE_ROOM"] = "LEAVE_ROOM";
    /**
     * Messages in Room
     * Can send multiple changesets at one time
     */
    SyncRequestTypes["CLIENT_ROOM_CHANGE"] = "CLIENT_ROOM_CHANGE";
    /**
     * ROOM message for NEST service
     */
    SyncRequestTypes["NEST_ROOM_CHANGE"] = "NEST_ROOM_CHANGE";
})(SyncRequestTypes = exports.SyncRequestTypes || (exports.SyncRequestTypes = {}));
/**
 * Type of message to broadcast
 */
var BroadcastTypes;
(function (BroadcastTypes) {
    /**
     * Other users in the room operated changeset
     * Because compared to the client, it is actively pushed by the server, so it starts with Server
     */
    BroadcastTypes["SERVER_ROOM_CHANGE"] = "SERVER_ROOM_CHANGE";
    /**
     * There are newly activated collaboration (multiple) people
     */
    BroadcastTypes["ACTIVATE_COLLABORATORS"] = "ACTIVATE_COLLABORATORS";
    /**
     * A collaborator has been deactivated
     */
    BroadcastTypes["DEACTIVATE_COLLABORATOR"] = "DEACTIVATE_COLLABORATOR";
    /**
     * A user updated the cursor
     */
    BroadcastTypes["ENGAGEMENT_CURSOR"] = "ENGAGEMENT_CURSOR";
    /**
     * Node sharing is turned off
     */
    BroadcastTypes["NODE_SHARE_DISABLED"] = "NODE_SHARE_DISABLED";
    /**
     * Field permission is enabled
     */
    BroadcastTypes["FIELD_PERMISSION_ENABLE"] = "FIELD_PERMISSION_ENABLE";
    /**
     * Field permission change
     */
    BroadcastTypes["FIELD_PERMISSION_CHANGE"] = "FIELD_PERMISSION_CHANGE";
    /**
     * Field permission off
     */
    BroadcastTypes["FIELD_PERMISSION_DISABLE"] = "FIELD_PERMISSION_DISABLE";
    /**
     * Field configuration property changes
     */
    BroadcastTypes["FIELD_PERMISSION_SETTING_CHANGE"] = "FIELD_PERMISSION_SETTING_CHANGE";
})(BroadcastTypes = exports.BroadcastTypes || (exports.BroadcastTypes = {}));
var OtErrorCode;
(function (OtErrorCode) {
    // server exception
    OtErrorCode[OtErrorCode["SERVER_ERROR"] = 4000] = "SERVER_ERROR";
    // message repeats
    OtErrorCode[OtErrorCode["MSG_ID_DUPLICATE"] = 4001] = "MSG_ID_DUPLICATE";
    // commit version conflict
    OtErrorCode[OtErrorCode["VERSION_CONFLICT"] = 4002] = "VERSION_CONFLICT";
    // Commit version overrun
    OtErrorCode[OtErrorCode["REVISION_OVER_LIMIT"] = 4003] = "REVISION_OVER_LIMIT";
    // commit version error
    OtErrorCode[OtErrorCode["REVISION_ERROR"] = 4004] = "REVISION_ERROR";
    // Failed to update column header
    OtErrorCode[OtErrorCode["APPLY_META_ERROR"] = 4005] = "APPLY_META_ERROR";
    // structure is missing
    OtErrorCode[OtErrorCode["META_LOST_ERROR"] = 4006] = "META_LOST_ERROR";
    // version numbers do not match
    OtErrorCode[OtErrorCode["MATCH_VERSION_ERROR"] = 4007] = "MATCH_VERSION_ERROR";
    // The space capacity exceeds the limit
    OtErrorCode[OtErrorCode["SPACE_CAPACITY_OVER_LIMIT"] = 4008] = "SPACE_CAPACITY_OVER_LIMIT";
    // cell data format write error
    OtErrorCode[OtErrorCode["DATA_FORMAT_ERROR"] = 4009] = "DATA_FORMAT_ERROR";
    // operation conflict
    OtErrorCode[OtErrorCode["OPERATION_CONFLICT"] = 4010] = "OPERATION_CONFLICT";
})(OtErrorCode = exports.OtErrorCode || (exports.OtErrorCode = {}));
//# sourceMappingURL=types.js.map